<template>
  <main class="container">
    <div class="row">
      <div class="col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-12 contact-page-wrap white-box">

				<div id="contact-html" v-html="contactHtml"></div>

  		</div>
    </div>
  </main>
</template>

<script>

import axios from 'axios'

export default {
  data() {
    return {
      contactHtml: false,
    }
  },
  created() {
    axios.get('https://apps.odenserundt.dk/data/odenserundt/texts/contact-dk.html')
    .then((response) => {
      this.contactHtml = response.data;
    })
    .catch(function (error) {
      console.log(error);
    });

    this.$HelperFunctions.scrollToTop();
    this.$HelperFunctions.setPageTitle('Kontakt');
  },
  mounted() {
    this.$HelperFunctions.setScreenReaderFocus();
  },
}
</script>

<style lang="scss" scoped>

  #contact-html ::v-deep a[href^="mailto:"] {
    text-decoration: underline;
  }

  .contact-page-wrap {
    position: relative;
    margin-top: 20px;
    height: 100%;
    overflow-y: auto;
    padding-top: 15px;
    padding-bottom: 15px;
  }
</style>
